<template>
  <span
    ><template v-for="(seg, index) in segments" :key="index"
      ><mark v-if="seg.match" class="rounded-[2px] bg-yellow-200 text-inherit dark:bg-yellow-500/40">{{
        seg.text
      }}</mark
      ><template v-else>{{ seg.text }}</template></template
    ></span
  >
</template>

<script setup lang="ts">
// Renders `text` with every case-insensitive occurrence of `query` wrapped in a <mark>, for search
// matches in the admin list tables. Segment logic is the pure highlightSegments helper.
import { computed } from "vue";

import { highlightSegments } from "../../utils/searchHighlight";

const props = withDefaults(defineProps<{ text?: string; query?: string }>(), {
  text: "",
  query: "",
});

const segments = computed(() => highlightSegments(props.text, props.query));
</script>
